<template>
  <!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="wrapper">
    <div class="container">
      <h3 class="h3">选择套餐</h3>
      <div class="main">
        <div class="item item-active" v-if="packageInfo.setMealName">
          <h4>{{packageInfo.setMealName}}</h4>
          <p>
            <template v-if="packageInfo.setMealAnnualFee == 1">
              <!-- 是否关联市场人员 -->
              <template v-if="packageInfo.setMealSales == 1">
                <template v-if="packageInfo.setMealFixedMoney == 1">{{packageInfo.setMealMoney}}元/年</template>
                <template v-else>
                  <span v-if="packageInfo.setMealMoneyMin">{{packageInfo.setMealMoneyMin}}~</span>
                  <span>{{packageInfo.setMealMoneyMax}}</span>
                  <span>元/年</span>
                </template>
              </template>
              <template v-else>
                {{packageInfo.setMealMoney}}元/年
              </template>
            </template>
            <template v-else>
              {{packageInfo.setMealMoney}}元/年
            </template>
          </p>
        </div>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn" @click="onSubmit">确定</div>
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { getMealInfo, getAnnualFeeInfo }  from '@/api/baseinfo';
export default {
  name: 'apply-package',
  data () {
    return {
      shopCode: undefined,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      packageInfo: {},
    }
  },
  created() {
    this.shopCode = this.$route.query ? this.$route.query.shopCode : undefined;
    this.getPackageInfo();
  },
  methods: {
    getPackageInfo() {
      getAnnualFeeInfo(this.shopCode).then(res => {
        if(res.data) {
          getMealInfo(res.data.setMealCode).then(mealRes => {
            if(mealRes.data) {
              let data = mealRes.data;
              data.setMealMoney = data.setMealMoney > 0 ? data.setMealMoney/100 : 0;
              data.setMealMoneyMin = data.setMealMoneyMin > 0 ? data.setMealMoneyMin/100 : 0;
              data.setMealMoneyMax = data.setMealMoneyMax > 0 ? data.setMealMoneyMax/100 : 0;
              this.packageInfo = data;
            }
          })
        }
      })
    },
    onSubmit() {
      this.$router.push({
        path: '/distribution/agreement?shopCode=' + this.shopCode
      })
      // if(this.packageInfo.setMealMoney > 0 || this.packageInfo.setMealMoneyMin > 0 || this.packageInfo.setMealMoneyMax > 0) {
      //   this.$router.push({
      //     path: '/distribution/agreement?shopCode=' + this.shopCode
      //   })
      // } else {
      //   this.$router.push({
      //     path: '/distribution/baseinfo-auth?shopCode=' + this.shopCode
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    .h3{
      width: 16.7rem;
      margin: .8rem auto 1.4rem;
      font-size: 1.2rem;
      color: #222222;
    }
  }
  .main{
    width: 16.75rem;
    margin: 0 auto;
    .item{
      max-width: 16.75rem;
      background: #FFFFFF;
      border-radius: .8rem;
      border: .1rem solid #CFE1EA;
      margin-bottom: 1.4rem;
      padding: 1.6rem 1.8rem;
      box-sizing: border-box;
      cursor: pointer;
      h4{
        font-size: 1.1rem;
        color: #222;
        margin-bottom: .35rem;
      }
      p{
        line-height: 1.5;
        font-size: .8rem;
        color: #999;
      }
    }
    .item-active{
      background: $base-color;
      border: .1rem solid $base-color;
      h4, p{
        color: #fff;
      }
    }
  }
}
@media screen and (min-width:750px){
  .container{
    padding-top: 1px;
    .h3{
      width: 334px;
      margin: 16px auto 28px;
      font-size: 24px;
      color: #222222;
    }
  }
  .main{
    width: 335px;
    margin: 0 auto;
    .item{
      max-width: 335px;
      background: #FFFFFF;
      border-radius: 16px;
      border: 2px solid #CFE1EA;
      margin-bottom: 28px;
      padding: 32px 36px;
      box-sizing: border-box;
      cursor: pointer;
      h4{
        font-size: 22px;
        color: #222;
        margin-bottom: 7px;
      }
      p{
        line-height: 1.5;
        font-size: 16px;
        color: #999;
      }
    }
    .item-active{
      background: $base-color;
      border: 2px solid $base-color;
      h4, p{
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/apply-package.vue